export default __webpack_public_path__ + "static/media/labs_security_certificaiton.60ddeb28.svg";